import type { BankAccount } from "@/scripts/Common";
import { isStringAndHasValue } from "@/scripts/Common/validators";

/**
 * Cleans up BankAccount object by converting null values to empty strings for API compatibility
 * @param bankAccount - The bank account object to clean
 * @returns Cleaned bank account object or null if input is null/undefined
 */
const cleanBankAccountForApi = (bankAccount: BankAccount): BankAccount => {
  return {
    id: bankAccount.id,
    iban: isStringAndHasValue(bankAccount.iban) ? bankAccount.iban : '',
    bic: isStringAndHasValue(bankAccount.bic) ? bankAccount.bic : '',
    creditInstitute: isStringAndHasValue(bankAccount.creditInstitute) ? bankAccount.creditInstitute : '',
    accountOwnerName: isStringAndHasValue(bankAccount.accountOwnerName) ? bankAccount.accountOwnerName : '',
  };
};

export {
  cleanBankAccountForApi,
};
